import Client from '../core';
export default class FeatureFlagClient {
  constructor(apiKey, analyticsWebClient, featureFlagUser, options) {
    this.client = new Client(apiKey, analyticsWebClient, featureFlagUser, options);
  }
  ready() {
    return this.client.ready();
  }
  setAutomaticExposuresEnabled(enabled, predicate) {
    this.client.setAutomaticExposuresEnabled(enabled, predicate);
  }
  getFlagValue(flagKey, defaultValue, options) {
    return this.client.getFlagValue(flagKey, defaultValue, options);
  }
  getFlagDetails(flagKey, defaultValue, options) {
    return this.client.getFlagDetails(flagKey, defaultValue, options);
  }
  getFlags() {
    return this.client.getFlags();
  }
  on(flagKey, defaultValue, callback, options) {
    return this.client.on(flagKey, defaultValue, callback, options);
  }
  onAnyFlagUpdated(callback) {
    return this.client.onAnyFlagUpdated(callback);
  }
  updateFeatureFlagUser(featureFlagUser) {
    return this.client.updateFeatureFlagUser(featureFlagUser);
  }
  destroy() {
    this.client.destroy();
  }
}